export default "__VITE_ASSET__26457970__"